import * as React from "react";
import AboutColor from "../containers/AboutColor";
import yellowQuotation from "../containers/AboutColor/yellowQuotation";
import yellowParrot from "../containers/AboutColor/yellowParrot.png";
import COLOR_TYPES from "../common/colors/type";
import t from "../translations";

export default (props) => (
  <AboutColor
    {...props}
    authorName={t("routes_YellowAboutColorsPageRoute_autorName")}
    title={t("routes_YellowAboutColorsPageRoute_title")}
    image={yellowParrot}
    quotation={yellowQuotation}
    colorType={COLOR_TYPES.YELLOW}
  />
);
